import { createAction } from '@reduxjs/toolkit';
import {
  APPLY_CHAT_REALTIME_MESSAGE,
  CLEAR_CHAT_THREAD,
  CREATE_CHAT_DIRECT,
  GET_CHAT_CONVERSATIONS,
  GET_CHAT_MESSAGES,
  GET_CHAT_UNREAD,
  MARK_CHAT_CONVERSATION_READ,
  SELECT_CHAT_CONVERSATION,
  SEND_CHAT_MESSAGE,
  SET_CHAT_HAS_UNREAD
} from '../constants';

export const getChatConversations = createAction(GET_CHAT_CONVERSATIONS);
export const getChatMessages = createAction(GET_CHAT_MESSAGES);
export const getChatUnread = createAction(GET_CHAT_UNREAD);
export const markChatConversationRead = createAction(MARK_CHAT_CONVERSATION_READ);
export const sendChatMessage = createAction(SEND_CHAT_MESSAGE);
export const createChatDirect = createAction(CREATE_CHAT_DIRECT);
export const selectChatConversation = createAction(SELECT_CHAT_CONVERSATION);
export const clearChatThread = createAction(CLEAR_CHAT_THREAD);
export const applyChatRealtimeMessage = createAction(APPLY_CHAT_REALTIME_MESSAGE);
export const setChatHasUnread = createAction(SET_CHAT_HAS_UNREAD);

export default {
  getChatConversations,
  getChatMessages,
  getChatUnread,
  markChatConversationRead,
  sendChatMessage,
  createChatDirect,
  selectChatConversation,
  clearChatThread,
  applyChatRealtimeMessage,
  setChatHasUnread
};
